var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "preview-schedule" }, [
        _vm._v("\n    " + _vm._s(_vm.duration) + " HORAS DE LIMPEZA\n    "),
        _vm.discounted_price
          ? _c("span", { staticClass: "with-discount" }, [
              _c("small", { staticClass: "discount" }, [
                _vm._v("DE " + _vm._s(_vm._f("intToCurrency")(_vm.price)))
              ]),
              _vm._v(
                "\n      POR " +
                  _vm._s(_vm._f("intToCurrency")(_vm.discounted_price)) +
                  "\n    "
              )
            ])
          : _c("span", [
              _vm._v("POR " + _vm._s(_vm._f("intToCurrency")(_vm.price)))
            ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Produtos de limpeza, transporte e alimentação do profissional inclusos."
          )
        ])
      ]),
      _vm._v(" "),
      _vm.preloader ? _c("loader") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c79ca8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c79ca8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/ConfirmPeriodAndPrice.vue
// module id = null
// module chunks = 